import React, { useState, useEffect, useLayoutEffect } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import CustomHeader from "./customHeader";
// import bgImg from "../assets/images/banner-img.jpg";
// import bgImg from "../assets/images/bannerBg.jpg";
import bgImg from "../assets/images/bg-4.jpg";

import { Typography, Rating, Button } from "@mui/material";
import ElectricCarIcon from "@mui/icons-material/ElectricCar";
import { green,customWhite } from "../constants/colors";
import NewsTicker from "./newsTicker";
import img from "../assets/images/text-slider-vec.svg";
import CustomMenu from "./customMenu";
import { useNavigate } from "react-router-dom";
import Header from "../container/carDetails/header";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const bannerStyle = {
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${bgImg})`,
  // background:"#C73336",
  backgroundSize: "cover",
  backgroundPosition: "center",
  overFlow: "hidden",
  backgroundRepeat: "no-repeat",
  // minHeight: "100vh",

};
export default function Banner({ landing }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  useLayoutEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box className="" style={bannerStyle} 
    sx={{
      flexGrow: 1,
      minHeight: { xs:"75vh", md: "100vh" }, // Responsive minHeight
    }}>
      {/* <CustomHeader landing="true" /> */}
      <div
        className={`mb-[70px] md:mb-[90px] transition-all duration-300 ease-in-out ${
          isScrolled ? "fixed top-0 left-0 right-0 shadow-md z-50" : ""
        }`}
        style={{
          background: isScrolled ? "#13141a" : "transparent",
          transition: "background 0.3s ease-in-out",
        }}
      >
        <CustomMenu landing="true" isScrolled={isScrolled} />
      </div>

      <Grid container spacing={2} >
        <Grid item sm={12} md={8} lg={7}>
          <Typography
            component="div"
            className="text-white px-4 md:px-10 md:ps-20 block xxl:pt-[50px]"
          >
            <Typography
              variant="p"
              className="font-bold text-[50px] md:text-[60px] lg:text-[80px] xl:text-[80px] xxl:text-[90px] leading-tight"
            >
              Sell & Purchase Your Dream Car with Trust
            </Typography>
            <Typography
              variant="p"
              component="div"
              className="text-[20px]"
              sx={{ mb: 5 }}
            >
              New or used, find the perfect car with our easy and <br />{" "}
              transparent process.
            </Typography>

            <div className="md:flex items-center gap-[40px]">
              <Button
                sx={{
                  background: green,
                  color: customWhite,
                  padding: "15px 30px",
                  textTransform: "capitalize",
                  fontWeight: 600,
                  marginBottom: { xs: "16px", md: "0px" },
                  ":hover": {
                    background: green,
                  },
                }}
                variant="contained"
                startIcon={<ElectricCarIcon />}
                onClick={() => navigate("/car-listing")}
              >
                Find Your Car
              </Button>
              {/* <Typography component="div">
                <Typography
                  component="div"
                  sx={{ display: "flex", gap: "10px" }}
                >
                  <Typography component="div">Trustpilot</Typography>
                  <Rating name="size-medium" defaultValue={5} />
                </Typography>
                <Typography
                  component="div"
                  sx={{ display: "flex", gap: "5px" }}
                >
                  <Typography component="div">Trust Rating 5.0 |</Typography>
                  <Typography component="div">2348 Reviews</Typography>
                </Typography>
              </Typography> */}
            </div>
          </Typography>
        </Grid>
        {/* <Col item lg={8} className="">
       
          <div className="mt-0">
            <CustomFilterBikes />
          </div>
        </Col> */}
      </Grid>
    </Box>
  );
}
